import navigation from './main-nav.js';

class SiteHeaderHomeKitProgram {
  constructor(element) {
    this.element = element;
    this.mobileMenuBtn = this.element.querySelector('[data-element="mobile-menu-btn"]');
    this.buttons = this.element.querySelectorAll('[data-element="site-nav-btn"]');
  }

  init() {
    this.buttons.forEach((element) => {
      element.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick() {
    if (navigation.isMobileViewport()) {
      navigation.closeMobileMenu(this.mobileMenuBtn);
    }
  }
}

const siteHeader = {
  init() {
    const header = document.querySelector('[data-module="site-header-home-kit-program"]');

    if (header) {
      const siteHeaderHomeKitProgram = new SiteHeaderHomeKitProgram(header);
      siteHeaderHomeKitProgram.init();
    }
  },
};

export default siteHeader;
